jQuery( document ).ready(function( $ ) {


 //$('.menu').dropit();


 //$( '.swipebox' ).swipebox();

 $('.mh-item').matchHeight();


 $('.iconBox__icon').matchHeight();
 $('.serviceBox .nb-6').matchHeight();
 $('.logoGrid__item').matchHeight();















});